import { makeStyles } from '@mui/styles';
import { transfer } from 'features/DigitalAccount/ReceivedDelegationList/ReceivedDelegation/components/TransferDelegation/services/TransferDelegationServices';
export const useStyles = makeStyles((theme) => ({
  containerActions: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  arrowList: {
    width: '23px',
    height: '23px',
    background: '#00000012',
    borderRadius: '50px',
    position: 'absolute',
    right: '36px',
    bottom: '29px',
    transition: 'all 0.3s ease 0s',
    [theme.breakpoints.down('sm')]: {
      right: '46px',
      bottom: '17px',

    },
    '&.isopen': {
      transform: 'rotate(180deg)',
      transition: 'all 0.3s ease 0s',

    }
  },
  reciveBtn: {
    width: '185px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: '0',
    },
  },
  reciveBtnFirst: {
    width: '185px',
    marginRight: '5px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginRight: '0',
    },
  },
  gridColumn: {
    flexDirection: 'row',
    display: 'flex',
    marginTop: '16px',
    gap: '12px',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',


    },
  },
  buttonProgress: {
    margin: '53px auto',
  },
  menuItem: {
    display: 'flex',
    height: '40px',
    lineHeight: '40px',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0 8px',
    width: '90%',
    margin: 'auto',
    borderBottom: '1px solid #3E4EAA1A',
    '&:last-child': {
      borderBottom: '0',
    },

    '&:hover': {
      background: '#3E4EAA1A',
      borderRadius: '5px',
    },
    '& svg': {
      marginRight: '5px',
    },
    '& span': {
      color: '#4A4A4A',
      fontWeight: '500',
      fontSize: '14px',
    },
  },
  box: {
    position: 'relative',
  },
  mainContent: {
    padding: '20px 0 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '12px 0 0',

    },
  },
  menu: {
    background: '#fff',
    position: 'absolute',
    zIndex: '1',
    transition: 'all 0.2s ease 0s',
    width: '228px',
    padding: '15px 0',
    borderRadius: '11px',
    boxShadow: '0px 4px 25px 0px #0000004D',
    marginTop: '12px',
  },
  description: {
    textAlign: 'left',
    color: '#9AA6B1',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  reciveBtn: {
    width: '185px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  blockReport: {
    width: '164px',
    background: '#3E4EAA0D',
    boxShadow: '0px 2px 4px 0px #00000026',
    height: '136px',
    flexDirection: 'column',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    '&.isopen': {

      background: '#3E4EAA26',

    },
    '& .MuiButton-label': {
      flexDirection: 'column',
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      gap: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      padding: ' 15px 0 ',
      margin: '0 ',
    },

    '& span': {
      color: '#4A4A4A',
      fontWeight: '500',
      fontSize: '14px',
    },
  },
  loadingContent: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    borderRadius: '34px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {

    },

  },
  btnDoing: {
    margin: '0 2px',
    [theme.breakpoints.down('sm')]: {
      margin: '0',
      marginBottom: '4px',
    },
  },
}));
